import {SET_LOCALE} from '../constants';

export function setLocale(locale) {
    return {
        type: SET_LOCALE,
        payload: locale
    };
}
